import { BracketsCurly, BookOpenText, Code, LinkSimple, MagnifyingGlass } from "@phosphor-icons/react";

export function NetworkVisual() {
  return (
    <div className="network-visual" aria-label="Coding agent connects through BlockRazor MCP to official knowledge sources">
      <div className="network-grid" aria-hidden="true" />
      <div className="network-route route-a" aria-hidden="true" />
      <div className="network-route route-b" aria-hidden="true" />
      <div className="network-route route-c" aria-hidden="true" />

      <div className="network-node agent-node">
        <Code size={24} weight="regular" />
        <span>Coding Agent</span>
      </div>

      <div className="network-node mcp-node">
        <img className="mcp-logo" src="/blockrazor-logo.png" alt="" />
        <span>MCP</span>
      </div>

      <div className="source-stack">
        <div className="network-node source-node">
          <BookOpenText size={22} />
          <span>Docs</span>
        </div>
        <div className="network-node source-node">
          <BracketsCurly size={22} />
          <span>API Guides</span>
        </div>
        <div className="network-node source-node">
          <LinkSimple size={22} />
          <span>Source Links</span>
        </div>
      </div>

      <MagnifyingGlass className="floating-search" size={18} aria-hidden="true" />
    </div>
  );
}
